import React, { useEffect, useState } from "react";
import "./All_Vegitables_Category_Slider.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCategories,
  getAllSubCategory,
} from "../../../features/master/masterSlice";

const All_Vegitables_Category_Slider = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [index, setIndex] = useState(false);

  const resto_category_slider = [
    {
      image: "/assets/images/products/vegetables/img1.png",
      name: "All",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Potatos",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Tomato",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Capsicum",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Capsicum",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Tomato",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Capsicum",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Capsicum",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
    {
      image: "/assets/images/products/vegetables/img2.png",
      name: "Broccoli",
    },
  ];

  const dispatch = useDispatch();

  const categories = useSelector((state) => state.master.subcategories);

  console.log(props?.categoryId, "props?.categoryId props?.categoryId");

  useEffect(() => {
    if (props?.categoryId) {
      dispatch(getAllSubCategory({ category_id: props?.categoryId }));
    }
  }, [dispatch, props?.categoryId]);

  return (
    <>
      <section className="All_Vegitables_category">
        <div className="container">
          <div className="slidersec">
            <Swiper
              modules={[Navigation]}
              navigation={true}
              breakpoints={{
                0: { slidesPerView: 4, spaceBetween: 10 },
                350: { slidesPerView: 4, spaceBetween: 10 },
                575: { slidesPerView: 5, spaceBetween: 10 },
                768: { slidesPerView: 6, spaceBetween: 10 },
                991: { slidesPerView: 8, spaceBetween: 10 },
                1200: { slidesPerView: 9, spaceBetween: 10 },
                1400: { slidesPerView: 10, spaceBetween: 20 },
              }}
              className="mySwiper All_Vegitables_category_slider category_slider "
            >
              <SwiperSlide
                key={"all"}
                onClick={() => {
                  setActiveIndex(0);
                  props?.setSubCategoryId(null);
                }}
              >
                <div
                  className={`sliderdiv ${activeIndex === 0 ? "active" : ""}`}
                >
                  <div
                    className={`imagediv ${activeIndex === 0 ? "active" : ""}`}
                  >
                    <img
                      className="slider-img"
                       src={process.env.REACT_APP_IMG_URL + props?.categoryImage}
                      // src={
                      //   process.env.PUBLIC_URL + resto_category_slider[0]?.image
                      // }
                      alt={resto_category_slider[0]?.name}
                    />
                  </div>
                  <p className="catname">{resto_category_slider[0]?.name}</p>
                </div>
              </SwiperSlide>

              {categories.map((data, idx) => {
                const slideIndex = idx + 1; // shift because first slide is 0
                return (
                  <SwiperSlide
                    key={slideIndex}
                    onClick={() => {
                      setActiveIndex(slideIndex);
                      props?.setSubCategoryId(data?.id);
                    }}
                  >
                    <div
                      className={`sliderdiv ${
                        activeIndex === slideIndex ? "active" : ""
                      }`}
                    >
                      <div
                        className={`imagediv ${
                          activeIndex === slideIndex ? "active" : ""
                        }`}
                      >
                        <img
                          className="slider-img"
                          src={process.env.REACT_APP_IMG_URL + data?.image}
                          alt={data?.name}
                        />
                      </div>
                      <p className="catname">{data?.name}</p>
                    </div>
                  </SwiperSlide>
                );
              })}

              {/* <SwiperSlide
                key={index}
                onClick={() => {
                  setActiveIndex(index);
                  props?.setSubCategoryId(null);
                }}
              >
                <div
                  className={`sliderdiv ${!index ? "active" : ""}`}
                  onClick={() => {
                    setActiveIndex(index);
                  }}
                >
                  <div className={`imagediv ${!index ? "active" : ""}`}>
                    <img
                      className="slider-img"
                      src={
                        process.env.PUBLIC_URL + resto_category_slider[0]?.image
                      }
                      alt={resto_category_slider[0]?.name}
                    />
                  </div>
                  <p className="catname">{resto_category_slider[0]?.name}</p>
                </div>
              </SwiperSlide>
              {categories.map((data, index) => (
                <SwiperSlide
                  key={index}
                  onClick={() => {
                    props?.setSubCategoryId(data?.id);
                  }}
                >
                  <div
                    className={`sliderdiv ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => setActiveIndex(index)}
                  >
                    <div
                      className={`imagediv ${
                        activeIndex === index ? "active" : ""
                      }`}
                    >
                      <img
                        className="slider-img"
                        src={process.env.REACT_APP_IMG_URL + data?.image}
                        alt={data?.name}
                      />
                    </div>
                    <p className="catname">{data?.name}</p>
                  </div>
                </SwiperSlide>
              ))} */}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default All_Vegitables_Category_Slider;
